import React from "react"
import { Col, Row } from "react-bootstrap"
import DefaultSort from "../DefaultSort"
import { SearchInput } from "../SearchInput"

export const SearchSortHeader = ({
  title,
  onChangeInput,
  hideSearch = true,
  searchPlaceholder = "Filter galleries",
  children,
  sort,
  sorts,
  setSort,
}) => {
  const cols = hideSearch ? 6 : 4
  return (
    <Row
      className={`align-items-center mb-4 justify-content-between${
        !title && hideSearch ? " flex-row-reverse" : ""
      }`}>
      {title && (
        <Col
          xs={hideSearch ? 5 : 12}
          sm={hideSearch ? 5 : 12}
          md={cols}
          className={`${hideSearch ? "" : "pb-3"} pb-md-0`}>
          <span className="fs-13px color-gray-super-light font-weight-normal">
            {title}
          </span>
        </Col>
      )}
      {!hideSearch && (
        <Col xs={12} md={cols} className="mb-md-0 mb-sm-4 mb-xs-4 mt-sm-3">
          <SearchInput
            searchPlaceholder={searchPlaceholder}
            onChange={onChangeInput}
          />
        </Col>
      )}
      <Col
        xs={hideSearch ? 7 : 12}
        sm={hideSearch ? 7 : 12}
        md={cols}
        className="text-right">
        <DefaultSort sort={sort} sorts={sorts} setSort={setSort} />
      </Col>
      {children && <Col xs={!title ? 5 : 12}>{children}</Col>}
    </Row>
  )
}
